import React from 'react';

const EuroCategory = ({ rowData }) => {
  const { euro_category } = rowData;
  return <div>{euro_category}</div>;
};

export default EuroCategory;
